import { inlines } from './inlines';
export const taskItem = (node, nestedLevel, {
  context
} = {}) => {
  let result = '';
  node.forEach(n => {
    // Generate stars based on depth
    const prefix = Array(nestedLevel).fill('*').join('');
    if (node.attrs.state === 'DONE') {
      result += `${prefix} -${inlines(n, {
        context
      })}-`;
    } else {
      result += `${prefix} ${inlines(n, {
        context
      })}`;
    }
  });
  return result;
};